import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import CtaButton from 'components/essentials/Cta/CtaButton';
import Link from 'components/consumer/Link';
import JBImage from 'components/essentials/JBImage';
import JBIFrameHolder from 'components/essentials/JBIFrameHolder';
import FinancingCtaButton from 'components/essentials/FinancingCtaButton';

const ToggleCTAImageLink = props => {
  const { imageProps, toggleInputType, isHovered } = props;
  const CTAComponentType = toggleInputType?.selected?.value
    ? toggleInputType.selected.value?.replace(' ', '')
    : '';
  const [iFrameVisibility, setiFrameVisibility] = useState(false);
  const [isButtonEmbedded] = useState(
    () =>
      !!(
        CTAComponentType === 'CTAButton' &&
        toggleInputType?.ctaButton?.embedCode?.enabled &&
        toggleInputType.ctaButton.embedCode?.value?.includes('<a ')
      )
  );
  let finalCTAButton = null;
  if (CTAComponentType === 'CTAButton' && toggleInputType.ctaButton) {
    if (
      toggleInputType.ctaButton.type &&
      (toggleInputType.ctaButton.type === 'Affirm' ||
        toggleInputType.ctaButton.type === 'Financing')
    ) {
      finalCTAButton = (
        <FinancingCtaButton styling="simple-img-button" isHovered={isHovered}>
          <JBImage
            src={imageProps.src}
            alt={imageProps.alt}
            className="half-image"
            crop="focalpoint"
            fpY={0.7}
            sizes="(max-width: 767px) 100vw, 50vw"
          />
        </FinancingCtaButton>
      );
    } else {
      finalCTAButton = (
        <CtaButton
          onClick={() => {
            setiFrameVisibility(true);
          }}
          styling="simple-button"
          isHovered={isHovered}
        >
          <JBImage
            src={imageProps.src}
            alt={imageProps.alt}
            className="half-image"
            crop="focalpoint"
            fpY={0.7}
            sizes="(max-width: 767px) 100vw, 50vw"
          />
        </CtaButton>
      );
    }
  }
  return (
    <>
      {CTAComponentType === 'CTALink' && !!toggleInputType.ctaLink && (
        <Link to={toggleInputType.ctaLink.linkTo}>
          <JBImage
            src={imageProps.src}
            alt={imageProps.alt}
            className="half-image"
            crop="focalpoint"
            fpY={0.7}
            sizes="(max-width: 767px) 100vw, 50vw"
          />
        </Link>
      )}
      {CTAComponentType === 'CTALink' && !toggleInputType?.ctaLink?.linkTo && (
        <JBImage
          src={imageProps.src}
          alt={imageProps.alt}
          className="half-image"
          crop="focalpoint"
          fpY={0.7}
          sizes="(max-width: 767px) 100vw, 50vw"
        />
      )}
      {CTAComponentType === 'CTAButton' &&
        !!toggleInputType.ctaButton &&
        toggleInputType.ctaButton.content && (
          <div>
            {toggleInputType.ctaButton.embedCode.enabled && isButtonEmbedded && (
              <div
                className="embed-button"
                dangerouslySetInnerHTML={{
                  __html: toggleInputType.ctaButton.embedCode.value,
                }}
              />
            )}
            {toggleInputType.ctaButton.embedCode.enabled &&
              !isButtonEmbedded &&
              iFrameVisibility && (
                <JBIFrameHolder
                  isOpen={iFrameVisibility}
                  onClose={setiFrameVisibility}
                  script={toggleInputType.ctaButton.embedCode.value || ''}
                />
              )}
            {!isButtonEmbedded && finalCTAButton}
          </div>
        )}
    </>
  );
};

ToggleCTAImageLink.propTypes = {
  toggleInputType: PropTypes.shape({
    ctaButton: PropTypes.shape({
      content: PropTypes.string,
      embedCode: PropTypes.shape({
        enabled: PropTypes.bool,
        value: PropTypes.string,
      }),
      type: PropTypes.string,
      color: PropTypes.string,
      style: PropTypes.string,
    }),
    ctaLink: PropTypes.shape({
      content: PropTypes.string,
      linkTo: PropTypes.string,
      color: PropTypes.string,
      style: PropTypes.string,
    }),
    selected: PropTypes.shape({
      value: PropTypes.string,
    }),
  }),
  style: PropTypes.shape({
    height: PropTypes.string,
    width: PropTypes.string,
  }),
  isHovered: PropTypes.bool,
  imageProps: PropTypes.shape({
    alt: PropTypes.string,
    sizes: PropTypes.string,
    src: PropTypes.string,
  }),
};

export default withRouter(ToggleCTAImageLink);
